export default "__VITE_ASSET__DGlPIcef__"